import * as React from "react";
import { TAvailableSurveyLanguages } from "../../types/Survey";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Theme } from "@mui/material/styles";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import SurveyTranslation from "./SurveyTranslation";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      width: "100%",
      marginTop: theme.typography.pxToRem(16),
      marginBottom: theme.typography.pxToRem(8),
    },
  })
);

interface ILanguageSelectorProps {
  languages: TAvailableSurveyLanguages;
  language: string;
  selectLanguage: string | null;
  changeSurveyLanguage: (lang: string) => void;
}

const LanguageSelector: React.FC<ILanguageSelectorProps> = ({
  languages,
  language,
  selectLanguage,
  changeSurveyLanguage,
}): JSX.Element => {
  const classes = useStyles({});

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel id="language-label">
        {selectLanguage !== null ? (
          <>{selectLanguage}</>
        ) : (
          <SurveyTranslation translate={"survey.language.select.label"} />
        )}
      </InputLabel>
      {language && (
        <Select
          labelId="language-label"
          id="language-select"
          value={language}
          onChange={(e) => changeSurveyLanguage(e.target.value as string)}
          label={
            selectLanguage !== null ? (
              <>{selectLanguage}</>
            ) : (
              <SurveyTranslation translate={"survey.language.select.label"} />
            )
          }
        >
          {languages.map((lang) => {
            return (
              <MenuItem
                value={lang.language.languageCode}
                key={lang.language.languageCode}
              >
                <SurveyTranslation translate={`generic.languages.${lang.language.languageCode}`} />
              </MenuItem>
            );
          })}
        </Select>
      )}
    </FormControl>
  );
};

export default LanguageSelector;
